import { render, staticRenderFns } from "./MatWidthSelector.vue?vue&type=template&id=c39640ee&scoped=true&"
import script from "./MatWidthSelector.vue?vue&type=script&lang=ts&"
export * from "./MatWidthSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MatWidthSelector.vue?vue&type=style&index=0&id=c39640ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39640ee",
  null
  
)

export default component.exports